import React from 'react';
import { IOrderParams, useListPagedOrdersByFilterParamsQuery } from '../../../../API/pcDashboard/getOrderAsync';
import { Card } from '@zillow/constellation';
import { MultiSelectOrdersTable } from './MultiSelectOrdersTable';
import { ErrorBoundaryConstellation } from '../../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';
import { cleanMultiSelectQueryRequest } from '../../filter/util/cleanMultiSelectQueryRequest';
import { createDefaultPageData } from '../../../../types/rest/IPageData';
import { TableCardHeader } from '../components/TableCardHeader';
import { RecentOrdersDrawer } from './RecentOrdersDrawer';
import { ISearchOrderData } from '../../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export const DashboardOrdersContainer: React.FC<{
  queryObject: IOrderParams;
  setQueryObject: (queryObject: IOrderParams) => void;
}> = ({ queryObject, setQueryObject }) => {
  const cleanedQueryObject = cleanMultiSelectQueryRequest(queryObject);

  const {
    data = createDefaultPageData<ISearchOrderData>(),
    isFetching,
    isSuccess,
    originalArgs,
    refetch,
  } = useListPagedOrdersByFilterParamsQuery(cleanedQueryObject);
  return (
    <ErrorBoundaryConstellation>
      <Card cardType={'secondary'} cardElevation={0}>
        <TableCardHeader refetch={refetch} title={'Orders'}>
          <RecentOrdersDrawer />
        </TableCardHeader>
        <MultiSelectOrdersTable
          setQueryObject={setQueryObject}
          data={data}
          originalArgs={originalArgs}
          isFetching={isFetching}
          isSuccess={isSuccess}
        />
      </Card>
    </ErrorBoundaryConstellation>
  );
};
